// extracted by mini-css-extract-plugin
export var dividerContainer = "_9i-0";
export var line = "_9i-1";